import { createContext, useContext } from 'react'
import { OperatorUserSession } from '@/features/auth/api/AuthModel'

type SessionContextProps = {
  session: OperatorUserSession
}

export const SessionContext = createContext<SessionContextProps>({} as SessionContextProps)

export const useSession = () => {
  const context = useContext(SessionContext)
  return context
}
